import React,{createContext,useContext,useState,useEffect,useCallback} from 'react';
import {authAPI} from '../utils/api';
const Ctx=createContext(null);
export const useAuth=()=>useContext(Ctx);

export const AuthProvider=({children})=>{
  const[user,setUser]=useState(null);
  const[loading,setLoading]=useState(true);

  useEffect(()=>{
    const token=localStorage.getItem('erp_token');
    const stored=localStorage.getItem('erp_user');

    if(!token){setLoading(false);return;}

    // Load stored user immediately so UI doesn't flicker
    if(stored){
      try{setUser(JSON.parse(stored));}catch{localStorage.clear();setLoading(false);return;}
    }

    // Always refresh from server to get latest branch_id, role, permissions
    authAPI.getProfile()
      .then(r=>{
        const fresh=r.data.user;
        localStorage.setItem('erp_user',JSON.stringify(fresh));
        setUser(fresh);
      })
      .catch(()=>{
        // Token invalid/expired — clear and force re-login
        localStorage.clear();
        setUser(null);
      })
      .finally(()=>setLoading(false));
  },[]);

  const login=async(email,password)=>{
    const{data}=await authAPI.login({email,password});
    localStorage.setItem('erp_token',data.token);
    localStorage.setItem('erp_user',JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout=useCallback(()=>{localStorage.clear();setUser(null)},[]);

  const hasPermission=useCallback(p=>{
    if(!user?.permissions)return false;
    if(user.permissions.length>=60)return true;
    return user.permissions.includes(p);
  },[user]);

  const isOwner=!!(user?.permissions&&user.permissions.length>=60);

  // Read branch_id from every possible location in the user object
  const myBranchId=isOwner?null:(
    user?.branch_id||
    user?.branch?.id||
    null
  );

  const myBranch=isOwner?null:(user?.branch||null);

  return(
    <Ctx.Provider value={{
      user,loading,login,logout,
      hasPermission,
      isAuthenticated:!!user,
      isOwner,
      myBranchId,
      myBranch,
    }}>
      {children}
    </Ctx.Provider>
  );
};
